import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectableButton } from '../SelectableButton';

export function DelayStep({ value, onChange }: { value?: number; onChange: (value: number) => void }) {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack gap={4}>
      <Typography>{t('reportIncident.steps.delay.description')}</Typography>
      <Stack direction="row" gap={2}>
        <SelectableButton isSelected={value === 5} onClick={() => onChange(5)} fullWidth>
          5 min
        </SelectableButton>
        <SelectableButton isSelected={value === 10} onClick={() => onChange(10)} fullWidth>
          10 min
        </SelectableButton>
      </Stack>
      <Stack direction="row" gap={2}>
        <SelectableButton isSelected={value === 15} onClick={() => onChange(15)} fullWidth>
          15 min
        </SelectableButton>
        <SelectableButton isSelected={value === 30} onClick={() => onChange(30)} fullWidth>
          30 min
        </SelectableButton>
      </Stack>
      <Stack direction="row" gap={2}>
        <SelectableButton isSelected={value === 45} onClick={() => onChange(45)} fullWidth>
          45 min
        </SelectableButton>
        <SelectableButton isSelected={value === 60} onClick={() => onChange(60)} fullWidth>
          1h {t('reportIncident.steps.delay.orMore')}
        </SelectableButton>
      </Stack>

      <SelectableButton isSelected={value === 0} onClick={() => onChange(0)} fullWidth>
        {t('reportIncident.steps.delay.noDelay')}
      </SelectableButton>
    </Stack>
  );
}
